<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn" [ngClass]="classes">
  {{ label }}
  <img src="assets/images/sort_123.png" alt="Logo" width="35" height="22" >
</button>
